import { render, staticRenderFns } from "./UploadImageComponent.vue?vue&type=template&id=2a063f04&scoped=true&"
import script from "./UploadImageComponent.vue?vue&type=script&lang=js&"
export * from "./UploadImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageComponent.vue?vue&type=style&index=0&id=2a063f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a063f04",
  null
  
)

export default component.exports